<template>

    <simple-layout
        :indicators="[{'title': nbUsers, 'subtitle': getVerbose('user_simple_layout_indicator_subtitle')}]"
        :models-loaded="true"
        :name="getVerbose('user_simple_layout_breadcrumb')"
        class="user-management"
    >
        <modal-edit-user
            ref="EditUser"
            :windowWidth="windowWidth"
            :groups="groups"
            @refreshTable="refreshTable"
        ></modal-edit-user>
        <div class="paginate-user">
            <h2>{{ getVerbose('user_page_title') }}</h2>

            <ns-loader
                ref="nsLoader"
                :toLoad="dataToLoad"
                @dataFetched="onDataFetched"
            >
                <div slot="content">

                    <div
                        v-if="windowWidth >= 500"
                        class="create-user"
                    >
                        <el-button
                            v-if="enableCreateUser && enableCreateUserByImportCsv"
                            type="primary"
                            style="position: relative;"
                            @click="openImportUser()"
                        >
                            <i class="ti-upload"></i>
                            <span>{{ getVerbose('user_button_import') }}</span>
                        </el-button>
                        <el-button
                            v-if="enableUnblockUser && $store.getters.userIsAtLeastAdmin"
                            type="primary"
                            style="position: relative;"
                            @click="unblockUsers()"
                        >
                            <i class="ti-unlock"></i>
                            <span>{{getVerbose('user_blocked_modal_title')}}</span>
                        </el-button>

                        <el-button
                            v-if="enableCreateUser"
                            type="primary"
                            style="position: relative;"
                            @click="openModalCreateUser"
                        >
                            <i class="ti-plus"></i>
                            <span>{{ getVerbose('user_button_create') }}</span>
                        </el-button>

                    </div>

                    <div
                        v-else
                        class="create-user"
                    >

                    <!-- need to contain the buttons in a div of their own, otherwise the tooltip created breaks the flex display and make the buttons slide -->
                        <div class="button-container-mobile">
                            <el-button
                                v-if="enableCreateUser"
                                type="primary"
                                style="position: relative;"
                                @click="openImportUser()"
                                v-tooltip.top="'Import list of users'"
                            >
                                <i class="ti-upload"></i>
                            </el-button>
                        </div>

                        <div>
                            <el-button
                                v-if="enableCreateUser"
                                type="primary"
                                style="position: relative;"
                                @click="openCreateUser()"
                                v-tooltip.top="'Create user'"
                            >
                                <i class="ti-plus"></i>
                            </el-button>
                        </div>
                        <div>
                            <el-button
                                v-if="enableUnblockUser && $store.getters.userIsAtLeastAdmin"
                                type="primary"
                                style="position: relative;"
                                @click="unblockUsers()"
                            >
                                <i class="ti-unlock"></i>
                                <span>{{getVerbose('user_blocked_modal_title')}}</span>
                            </el-button>
                        </div>
                    </div>
                    <ns-paginate
                        ref="nsPaginate"
                        v-model="users"
                        baseUrl="user/"
                        :customFiltersToApply="customFiltersToApply"
                        :onResetFilters="onResetFilters"
                        :displayCsvButton="enableDownloadCsvUsers"
                    >
                        <div slot="custom-input">
                            <el-row :gutter="40">
                                <el-col :span="12">
                                    <span style="white-space: nowrap;">{{ getVerbose('user_ns_paginate_filter_level') }}</span><br><br>
                                    <el-select
                                        v-model="selectedLevel"
                                        :clearable="true"
                                        :placeholder="getVerbose('user_ns_paginate_filter_level_placeholder')"
                                        style="width: 100%; margin-bottom: 15px;"
                                    >
                                        <el-option
                                            :label="getVerbose('user_ns_paginate_filter_level_option_superuser')"
                                            value="superuser"
                                        >
                                        </el-option>
                                        <el-option
                                            :label="getVerbose('user_ns_paginate_filter_level_option_admin')"
                                            value="admin"
                                        >
                                        </el-option>
                                        <el-option
                                            :label="getVerbose('user_ns_paginate_filter_level_option_manager')"
                                            value="manager"
                                        >
                                        </el-option>
                                        <el-option
                                            :label="getVerbose('user_ns_paginate_filter_level_option_simple')"
                                            value="simpleuser"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-col>
                                <slot
                                    name="extra-filter"
                                ></slot>
                            </el-row>
                        </div>
                        <div
                            slot="list"
                            slot-scope="props"
                        >
                            <el-table
                                :data="props.list"
                            >
                                <el-table-column
                                    prop="verbose_name"
                                    :label="getVerbose('user_ns_paginate_table_label_email')"
                                >
                                </el-table-column>
                                <el-table-column
                                    v-if="displayFirstLastNameColumnInUsersTable"
                                    prop="first_name"
                                    :label="getVerbose('user_ns_paginate_table_label_first_name')"
                                >
                                </el-table-column>
                                <el-table-column
                                    v-if="displayFirstLastNameColumnInUsersTable"
                                    prop="last_name"
                                    :label="getVerbose('user_ns_paginate_table_label_last_name')"
                                >
                                </el-table-column>
                                <el-table-column
                                    :label="getVerbose('user_ns_paginate_table_label_level')"
                                    prop="level"
                                    width="100px"
                                >
                                </el-table-column>
                                <el-table-column v-if="displayGroupsColumnInUsersTable" :label="getVerbose('user_ns_paginate_table_label_groups')">
                                    <template slot-scope="scope">
                                        <el-tag
                                            v-tooltip.top="group"
                                            v-for="(group, index) in groupsWithUser(scope.row)"
                                            :key="index"
                                            class="tag-group"
                                            type="info"
                                            disable-transitions>
                                            {{ group }}
                                        </el-tag>
                                    </template>
                                </el-table-column>
                                <slot
                                    :user="users"
                                    name="extra-column">
                                </slot>
                                <el-table-column
                                    :label="getVerbose('user_ns_paginate_table_label_actions')"
                                    :width="`${actionColumnWidth}px`"
                                >
                                    <template slot-scope="scope">
                                        <el-button-group
                                            ref="actionButtons"
                                            class="user-action-button"
                                            @hook:mounted="calcActionColumnWidth"
                                        >
                                            <el-button
                                                v-tooltip.top="{
                                                    class: 'user-tooltip',
                                                    content: getVerbose('user_ns_paginate_table_label_actions_edit_tooltip')
                                                }"
                                                type="primary"
                                                icon="ti-pencil"
                                                @click="openModalpatchUser(scope.row, true)"
                                            ></el-button>

                                            <el-button
                                                v-tooltip.top="{
                                                    class: 'user-tooltip',
                                                    content: getVerbose('user_ns_paginate_table_label_actions_manage_group_tooltip')
                                                }"
                                                v-if="enableGroupsAdministration && displayGroupsColumnInUsersTable"
                                                type="primary"
                                                icon="ti-user"
                                                style="position: relative;"
                                                @click="manageGroups(scope.row)"
                                            >
                                                <i class="ti-user ti-override-group ti-override-group-left"></i>
                                                <i class="ti-user ti-override-group ti-override-group-right"></i>
                                            </el-button>

                                            <el-button
                                                :disabled="!canAdministrateUser(scope.row)"
                                                v-tooltip.top="{
                                                    class: 'user-tooltip',
                                                    content: !canAdministrateUser(scope.row) ? getVerbose('user_ns_paginate_table_label_actions_delete_not_available_tooltip') : getVerbose('user_ns_paginate_table_label_actions_delete_tooltip')
                                                }"
                                                type="primary"
                                                icon="ti-trash"
                                                @click="deleteUser(scope.row)"
                                            >
                                            </el-button>
                                            <el-button
                                                v-if="enablePermissionAdministration"
                                                :disabled="!canAdministrateUser(scope.row)"
                                                v-tooltip.top="{
                                                    class: 'user-tooltip',
                                                    content: !canAdministrateUser(scope.row) ? getVerbose('user_ns_paginate_table_label_actions_manage_role_not_available_tooltip') : getVerbose('user_ns_paginate_table_label_actions_manage_role_tooltip')
                                                }"
                                                type="primary"
                                                icon="ti-medall"
                                                @click="manageUserRole(scope.row)"
                                            >
                                            </el-button>

                                            <el-button
                                                :disabled="!canAdministrateUser(scope.row) || !userPasswordChangeable(scope.row)"
                                                v-tooltip.top="{
                                                    class: 'user-tooltip',
                                                    content: passwordManagementTooltipContent(scope.row)
                                                }"
                                                type="primary"
                                                icon="ti-key"
                                                @click="editPassword(scope.row)"
                                            >
                                            </el-button>
                                            <slot
                                                :user="scope.row"
                                                name="extra-buttons"
                                            ></slot>

                                        </el-button-group>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </ns-paginate>
                </div>
            </ns-loader>
        </div>
        <modal-manager-user-roles ref="modalManageRoles"></modal-manager-user-roles>
        <modal-unblock-user ref="modalUnblockUsers" :getVerbose="getVerbose" @usersUnblocked="reloadUsers"></modal-unblock-user>
        <modal-password-security ref="modalSecurity"></modal-password-security>
    </simple-layout>
</template>

<script>

import NsPaginate from '../../partials/nsPaginate2';
import NsLoader from '../../partials/ns-vue-loader.vue';
import UserAction from './user-action.vue';
import ModalForm from '../../partials/modal-form.js';
import UserGroupsModal from './edit-user-groups-modal.vue';
import ImportUserModal from './import-user-modal.vue';
import {mapGetters} from 'vuex';
import schwartz from 'schwartz';
import ModalEditUser from './modal-edit-user';
import ModalManagerUserRoles from './modal-manage-user-role.vue';
import ModalUnblockUser from './modal-unblock-user.vue';
import ModalPasswordSecurity from './modal-password-security.vue';

export default {

    components: {
        NsPaginate,
        UserAction,
        NsLoader,
        ModalEditUser,
        ModalManagerUserRoles,
        ModalUnblockUser,
        ModalPasswordSecurity,
    },

    props: {
        customFilter: {
            type: Object,
            required: false,
            default (){
                return {};
            },
        },
    },

    data (){
        return {
            windowWidth: 0,
            levels: [
                {
                    label: '',
                    value: 'superuser',
                    strength: 4
                },
                {
                    label: '',
                    value: 'admin',
                    strength: 3
                },
                {
                    label: '',
                    value: 'manager',
                    strength: 2
                },
                {
                    label: '',
                    value: 'simpleuser',
                    strength: 1
                },
                {
                    label: '',
                    value: 'blocked',
                    strength: 0,
                },
            ],
            selectedLevel: '',
            groups: [],
            users: {},
            nbUsers: 0,
            actionColumnWidth: '',
        };
    },

    computed: {
        ...mapGetters('fundation', [
            'enableCreateUser',
            'userExtraEditableFields',
            'enablePermissionAdministration',
            'enableDownloadCsvUsers',
            'enableGroupsAdministration',
            'getVerbose',
            'displayFirstLastNameColumnInUsersTable',
            'displayGroupsColumnInUsersTable',
            'enableCreateUserByImportCsv',
            'enableUnblockUser',
        ]),
        ...mapGetters([
            'userPasswordChangeable',
        ]),
        currentUserStrength (){
            return this.levels.find((level) => {
                return level.value === this.$store.getters.currentUser.level.toLowerCase();
            }).strength;
        },
        groupsInOrder() {
            return schwartz(this.groups, (group) => {group.name;});
        },
        dataToLoad() {
            if(this.enableGroupsAdministration) {
                return [{name: 'groups', model: 'groups', filters: {ordering: 'name'}}];
            }
            return [];
        },
    },

    watch: {
        '$store.getters.scopes': {
            handler() {
                this.$refs.nsPaginate.loadContent();
            },
            deep: true,
        },
        users(val) {
            this.nbUsers = val.total_objects_count;
        }
    },

    created (){
        if(!this.$store.getters.enableUsersSideBarMenu){
            this.$router.push('/');
        }
    },
    mounted() {
        let userStrengthLabels = [
            'user_strength_level_superuser',
            'user_strength_level_admin',
            'user_strength_level_manager',
            'user_strength_level_simple',
            'user_strength_level_blocked',
        ];
        this.levels.forEach((level, index) => {
            level.label = userStrengthLabels[index];
        });
        this.setWindowWidthForUserView();
        window.addEventListener('resize', this.setWindowWidthForUserView);
    },
    destroyed() {
        window.removeEventListener('resize', this.setWindowWidthForUserView);
    },
    methods: {
        passwordManagementTooltipContent(user) {
            if (this.canAdministrateUser(user)) {
                if (!this.userPasswordChangeable(user)) {
                    return this.getVerbose('user_ns_paginate_table_label_actions_edit_password_not_available_tooltip');
                }
                return this.getVerbose('user_ns_paginate_table_label_actions_edit_password_tooltip');
            } else {
                return this.getVerbose('user_ns_paginate_table_label_actions_edit_password_not_available_tooltip');
            }
            // return !this.canAdministrateUser(user) ? this.getVerbose('user_ns_paginate_table_label_actions_edit_password_not_available_tooltip') : this.getVerbose('user_ns_paginate_table_label_actions_edit_password_tooltip');
        },
        reloadUsers (){
            this.$refs.nsPaginate.loadContent();
        },
        setWindowWidthForUserView() {
            this.windowWidth = window.innerWidth;
        },
        calcActionColumnWidth (){
            let btnWidth = 56;
            let someSpace = 20;

            this.actionColumnWidth = (this.$refs.actionButtons.$children.length * btnWidth) + someSpace;
        },

        refreshTable() {
            this.$refs.nsLoader.triggerRefresh();
            this.$refs.nsPaginate.loadContent();
            this.$refs.EditUser.close();
        },

        onResetFilters (){
            this.selectedLevel = '';
            this.$emit('filter-reseted');
            this.$refs.nsPaginate.loadContent();
        },

        onDataFetched (res){
            if(res.groups) {
                this.$set(this, 'groups', res.groups);
            } else {
                this.$set(this, 'groups', []);
            }
        },

        customFiltersToApply (){
            let filters = {
                level: this.selectedLevel,
                ordering: 'email'
            };

            return Object.assign({}, filters, this.customFilter);
        },

        openModalpatchUser (user){
            this.$refs.EditUser.open({ user: user }, true);
        },

        openModalCreateUser (){
            this.$refs.EditUser.open({ user: {} }, false);
        },

        updateUserGroups (user){

            let addedGroups = user.addedGroups || [];
            let deletedGroups = user.deletedGroups || [];

            addedGroups = addedGroups.map(uid => {
                return this.groups.find((group) => group.uid === uid);
            }).filter(Boolean);
            deletedGroups = deletedGroups.map(uid => {
                return this.groups.find((group) => group.uid === uid);
            }).filter(Boolean);

            let users = [user];
            return Promise.all([
                this.$store.dispatch(
                    'fundation/addUsersToGroups',
                    {
                        users: users,
                        groups: addedGroups
                    }
                ),
                this.$store.dispatch(
                    'fundation/removeUsersFromGroups',
                    {
                        users: users,
                        groups: deletedGroups
                    }
                ),
            ]).then(() => {
                this.$notify.success({title: this.getVerbose('user_update_success_title'), message: `${this.getVerbose('user_update_success_message_beginnning')} ${user.email} ${this.getVerbose('user_update_success_message_end')}`});
                this.$refs.nsPaginate.loadContent();
            }).catch((error) => {
                console.error(error);
                this.$notify.error({title: this.getVerbose('user_update_failure_title'), message: `${this.getVerbose('user_update_failure_message_beginnning')} ${user.email} ${this.getVerbose('user_update_failure_message_end')}`});
            });
        },

        editPassword (user){
            this.$refs.modalSecurity.open(user);
        },
        async importUsers ({emails, groups}){
            // Create users
            let promises = [];
            let users = [];
            for(let email of emails){
                promises.push(
                    this.$store.dispatch(
                        'fundation/createUserAccount', email
                    )
                );
            }

            try{
                users = await Promise.all(promises);
            }
            catch(error){
                return Promise.reject(error);
            }

            promises = [];

            // Add users to each groups
            for(let group of groups){
                promises.push(
                    this.$store.dispatch(
                        'fundation/addUsersToGroup',
                        {users, group}
                    )
                );
            }

            return Promise.all(promises);
        },

        deleteUser (user){
            this.$confirm(this.getVerbose('user_deletion_warning_message'), this.getVerbose('user_deletion_warning_title'), {
                confirmButtonText: this.getVerbose('user_deletion_warning_button_confirm'),
                cancelButtonText: this.getVerbose('user_deletion_warning_button_cancel'),
                type: 'warning'
            }).then(() => {
                this.$store.dispatch('fundation/deleteUser', user).then(() => {
                    this.$notify.success({
                        title: this.getVerbose('user_deletion_success_title'),
                        message: `${this.getVerbose('user_deletion_success_message_beginning')} ${user.verbose_name} ${this.getVerbose('user_deletion_success_message_end')}`
                    });
                    this.$refs.nsPaginate.loadContent();
                }).catch((e) => {
                    console.error(e);
                    this.$notify.error({
                        title: this.getVerbose('user_deletion_failure_title'),
                        message: `${this.getVerbose('user_deletion_failure_message')} ${user.verbose_name} `
                    });
                });
            });
        },

        manageGroups (user){
            ModalForm.display(
                this,
                UserGroupsModal,
                {
                    groups: this.groupsInOrder,
                    user: user,
                    getVerbose: this.getVerbose,
                    customClassName: 'manage-group-modal',
                },
                `${this.getVerbose('user_modal_manage_group_title_beginning')} ${user.verbose_name} ${this.getVerbose('user_modal_manage_group_title_end')}`,
                this.updateUserGroups
            );
        },
        unblockUsers (){
            this.$refs.modalUnblockUsers.open();
        },
        openImportUser (){
            ModalForm.display(
                this,
                ImportUserModal,
                {
                    groups: this.groupsInOrder,
                    customClassName: 'modal-import-user',
                    getVerbose: this.getVerbose,
                    windowWidth: this.windowWidth
                },
                this.getVerbose('user_modal_import_users_title'),
                this.importUsers
            );
        },

        groupsWithUser (user){
            return this.groups.map((group) => {
                if(group.members_uid.includes(user.uid)){
                    return group.name;
                }
                return null;
            }).filter(Boolean);
        },

        canAdministrateUser (user){
            if(this.currentUserStrength < 2) { return false; }
            if(user.uid === this.$store.getters.currentUser.uid){
                return true;
            }
            let userStrength = this.levels.find((level) => {
                return level.value === user.level.toLowerCase();
            }).strength;

            return this.currentUserStrength > userStrength;
        },

        manageUserRole (user){
            this.$refs.modalManageRoles.init(user);
        },
    },
};
</script>

<style lang="scss">
.user-tooltip {
    z-index: 800;
}
.modal-import-user{
    width: 80%;
}
.paginate-user{
    .tag-group{
        margin-right: 5px;
        margin-bottom: 5px;

        max-width: 100px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .ti-override-group{
        font-size: 12px;
        position: absolute;
        top: 11px;
    }
    .ti-override-group-left{
        left:14px;
    }
    .ti-override-group-right{
        right:14px;
    }

    .create-user{
        display: flex;
        justify-content: flex-end;
        margin-right: 30px;
        .ti-plus{
            margin-right: 5px;
            font-size: 15px;
        }
        .button-container-mobile {
            margin-right: 10px;
        }
    }

    .user-action-button button{
        margin-bottom: 5px;
    }
}
</style>



// WEBPACK FOOTER //
// node_modules/fundation-app-vuejs/src/components/usersManagement/user/index.vue